import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

interface BtnImgStyleProps {
    backGroundImg: string;
    backGroundColor?: string;
    width?: number;
    height?: number;
    radius?: number;
    isOnClick?: boolean;
}

export const ButtonImg = styled.button<BtnImgStyleProps>`
    ${(props) =>
        props.width
            ? css`
                  width: ${props.width}px;
              `
            : null}
    ${(props) =>
        props.height
            ? css`
                  height: ${props.height}px;
              `
            : null}
    ${(props) =>
        props.radius
            ? css`
                  border-radius: ${props.radius}px;
              `
            : null}
    ${(props) =>
        props.isOnClick
            ? css`
                  cursor: pointer;
              `
            : null}
    text-align: center;
    border: 0;
    background-size: 100% 100%;
    background-position: center;    
    background-image: url(${(props) => props.backGroundImg});
    background-repeat: no-repeat;
    ${(props) => (props.backGroundColor ? css`background-color: ${palette(props.backGroundColor)};` : null)}
    outline: none;

`;
